module.exports = __webpack_public_path__ + "static/media/icon-lock.01897a04.svg";